'use strict';

var ServiceDemandDowFilterFactory = function ServiceDemandDowFilterFactory(DataFilter) {
  function ServiceDemandDowFilter() {
    DataFilter.call(this, 'service', 'serviceDow');
  }
  ServiceDemandDowFilter.constructor = ServiceDemandDowFilter;
  ServiceDemandDowFilter.prototype = Object.create(DataFilter.prototype);
  ServiceDemandDowFilter.prototype.groupBy = 'departureDateMomentDDD';
  return ServiceDemandDowFilter;
};
ServiceDemandDowFilterFactory.$inject = ['DataFilterFactory'];
module.exports = ServiceDemandDowFilterFactory;